import { IArchivingExportModalConfig }                        from '@app/modules/archiving/config/archiving-export-modal.config';
import { IArchivingProceduralDocumentationExportModalConfig } from '@app/modules/archiving/config/archiving-procedural-documentation-export-modal.config';
import { IArchivingTssLogExportModalConfig }                  from '@app/modules/archiving/config/archiving-tss-log-export-modal.config';
import { ArchivingExportFormService }                         from '@app/modules/archiving/modals/archiving-export-modal/archiving-export-form.service';
import { ArchivingProceduralDocumentationExportFormService }  from '@app/modules/archiving/modals/archiving-procedural-documentation-export-modal/archiving-procedural-documentation-export-form.service';
import { ArchivingTssLogExportFormService }                   from '@app/modules/archiving/modals/archiving-tss-log-export-modal/archiving-tss-log-export-form.service';
import { IOpenArchiveBulkExportModalConfig }                  from '@app/modules/archiving/modals/open-archive/open-archive-bulk-export-modal/open-archive-bulk-export-modal.config';
import { ArchivingExport }                                    from '@app/modules/archiving/models/archiving-export.model';
import { ArchivingImport }                                    from '@app/modules/archiving/models/archiving-import.model';
import { ArchivingProceduralDocumentationExport }             from '@app/modules/archiving/models/archiving-procedural-documentation-export.model';
import { ArchivingProceduralDocumentation }                   from '@app/modules/archiving/models/archiving-procedural-documentation.model';
import { ArchivingTssLogExport }                              from '@app/modules/archiving/models/archiving-tss-log-export.model';
import { ArchivingTssLog }                                    from '@app/modules/archiving/models/archiving-tss-log.model';
import { OpenArchiveExport }                                  from '@app/modules/archiving/models/open-archive-export.model';
import { OpenArchive }                                        from '@app/modules/archiving/models/open-archive.model';
import { ArchivingImportService }                             from '@app/modules/archiving/services/archiving-import.service';
import { ArchivingProceduralDocumentationService }            from '@app/modules/archiving/services/archiving-procedural-documentation.service';
import { ArchivingTssLogService }                             from '@app/modules/archiving/services/archiving-tss-log.service';
import { OpenArchiveService }                                 from '@app/modules/archiving/services/open-archive.service';

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class ArchivingFingerprintTMO {
	algorithm?: string = undefined;
	hash?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ArchivingFingerprint extends ArchivingFingerprintTMO {}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IArchivingExportMode {
	mode: ArchivingExportModeEnum;

	order: number;

	hide: boolean;
}

export interface IArchivingSelectCheckboxType {
	[ key: string ]: boolean;
}

// TYPES #############################################################
export type ArchivingExportModalConfigType =
	IArchivingExportModalConfig
	| IArchivingTssLogExportModalConfig
	| IArchivingProceduralDocumentationExportModalConfig
	| IOpenArchiveBulkExportModalConfig;

export type ArchivingEntity = ArchivingImport | ArchivingTssLog | ArchivingProceduralDocumentation | OpenArchive;

export type ArchivingExportEntity = ArchivingExport | ArchivingTssLogExport | ArchivingProceduralDocumentationExport | OpenArchiveExport;

export type ArchivingEntityService = ArchivingImportService | ArchivingTssLogService | ArchivingProceduralDocumentationService | OpenArchiveService;

export type ArchivingEntityExportFormService =
	ArchivingExportFormService
	| ArchivingTssLogExportFormService
	| ArchivingProceduralDocumentationExportFormService;

// ENUMS #############################################################
// API enums ********************************************************


// UI enums *********************************************************
export enum ArchivingExportModeEnum {
	LIST = 'list',
	DATE = 'date',
	FILTER = 'filter'
}

export enum ArchivingExportDateType {
	BUSINESS_DATE = 'businessDate',
	CREATED_DATE = 'createdDate'
}

export enum ArchivingExportModalActions {
	ABORT = 'abort',
	CONFIRM = 'confirm',
	SUCCESS = 'success',
	ERROR = 'error'
}

export enum ArchivingEntityTypeEnum {
	IMPORT = 'import',
	TSS_LOG = 'tss_log',
	OPEN_ARCHIVE = 'openArchive',
	PROCEDURAL_DOCUMENTATION = 'procedural_documentation',
}
